import { useContext } from 'react';
import { RouteContext } from './route-context';
import { DefaultSearchOptions, SetSearchOptions, UseRouter } from './types';

/**
 * React hook that exposes the following router state/methods:
 * - currentHashValue - the hash value for the current/active route
 * - currentURL - the URL object for the current/active route
 * - searchOptions - data model representing the current search state (typed using the optional S generic)
 * - navigate - method to navigate to a pre-defined route
 * - prevPathName - the url of the previous view, use `usePreviousRouteAndState` hook to get previous route info
 * - setSearchOptions - method to set the current search state (typed using the optional S generic), which
 * will modify the URL's search/query-params without causing a browser refresh. The current search options
 * can be cleared by calling method with no parameter/arg
 */
export function useRouter<S extends DefaultSearchOptions>(): UseRouter<S> {
  const router = useContext(RouteContext);

  return {
    currentHashValue: router.currentHashValue,
    currentURL: router.currentURL,
    searchOptions: <S>router.searchOptions,
    navigate: router.navigate,
    prevPathname: router.prevPathname,
    setSearchOptions: <SetSearchOptions<S>>router.setSearchOptions,
  };
}
